export default {_name:'button.dialog',module:'Field',view:'Element/Button',options:{variant:'contained',fullWidth:false,color:'primary',xs:'auto'}}